import React from "react";
import { Form } from "antd";
import { InputText } from "@comps/components";
import { getErrorProps } from "@utils/helpers";
import TextArea from "antd/es/input/TextArea";

const CaseStatusForm = ({ onFinish, initialData, formName, errors, setErrors }) => {


  return (
    <Form
      layout="vertical"
      name={ formName }
      onFinish={ onFinish }
      initialValues={ initialData }
    >
      <Form.Item onChange={
        () => setErrors([])
      } name="name" rules={ rules.name } label="Name :" className="da-mb-16"
        { ...getErrorProps(errors['name']) }
      >
        <InputText placeholder="Enter your Status name" />
      </Form.Item>
      <Form.Item onChange={
        () => setErrors([])
      } name="order" rules={ rules.order } label="Order :" className="da-mb-16"
        { ...getErrorProps(errors['order']) }
      >
        <InputText type="number" placeholder="Enter your order" />
      </Form.Item>
      <Form.Item onChange={
        () => setErrors([])
      } name="description" rules={ rules.description } label="Description :" className="da-mb-16"
        { ...getErrorProps(errors['description']) }
      >
        <TextArea placeholder="Enter your role description" />
      </Form.Item>
    </Form>
  )
}


const rules = {
  name: [
    { required: true, message: 'Please input your name!', },
    { min: 3, message: 'Minimum name length is 3', },
    { max: 100, message: 'Maximum name length is 100', },
  ]
};


export default CaseStatusForm;